import i18n from 'src/i18n/i18n'

const businessPartnerTypes = {
  CUSTOMER: 'customer',
  SUPPLIER: 'supplier',
  CUSTOMER_AND_SUPPLIER: 'customer_and_supplier',
  OTHER: 'other'
}

const selectOptions = [
  { value: businessPartnerTypes.CUSTOMER, 'label': i18n.t('business_partner_type_customer') },
  { value: businessPartnerTypes.SUPPLIER, 'label': i18n.t('business_partner_type_supplier') },
  { value: businessPartnerTypes.CUSTOMER_AND_SUPPLIER, 'label': i18n.t('business_partner_type_customer_and_supplier') },
  { value: businessPartnerTypes.OTHER, 'label': i18n.t('business_partner_type_other') }
]

export { businessPartnerTypes, selectOptions as businessPartnerTypesSelectOptions }
